import { render, staticRenderFns } from "./PartnerInfo.vue?vue&type=template&id=537dbf4e&scoped=true"
import script from "./PartnerInfo.vue?vue&type=script&lang=js"
export * from "./PartnerInfo.vue?vue&type=script&lang=js"
import style0 from "./PartnerInfo.vue?vue&type=style&index=0&id=537dbf4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537dbf4e",
  null
  
)

export default component.exports